/* Cactus Warehouse cart add-ons (Sep 17 2026).
   Reads the data attributes rendered by snippets/cart-addons.liquid after every cart render and
   makes the cart match: adds gift lines the cart has earned, removes gifts it no longer earns,
   swaps the Protection variant when the price band changes, and handles the two add-on checkboxes.
   After any change it asks the theme to re-render (drawer: dispatch:cart-drawer:refresh, page: cart-items.refreshCartItems). */
(function () {
  if (window.cwAddonsBound) return;
  window.cwAddonsBound = true;

  var busy = false;
  var attempts = {};

  function routes() {
    var r = (window.theme && window.theme.routes) || {};
    return {
      add: r.cartAdd || '/cart/add',
      change: r.cartChange || '/cart/change',
      update: r.cartUpdate || '/cart/update'
    };
  }

  function post(url, body) {
    return fetch(url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function refresh(root) {
    var drawer = document.querySelector('cart-drawer');
    var cartItems = document.querySelector('cart-items');
    if (root && root.dataset.context === 'page' && cartItems && typeof cartItems.refreshCartItems === 'function') {
      cartItems.refreshCartItems();
      // the add-ons block sits outside cart-items on the page; reload it via the section endpoint
      reloadPageAddons();
    } else if (drawer) {
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
    } else {
      window.location.reload();
    }
  }

  function reloadPageAddons() {
    var holder = document.getElementById('cw-addons-page');
    if (!holder) return;
    var section = holder.dataset.section;
    if (!section) return;
    fetch(window.location.pathname + '?sections=' + section)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[section];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('cw-addons-page');
        if (fresh) holder.innerHTML = fresh.innerHTML;
        var subtotal = doc.getElementById('cart-summary');
        var cur = document.getElementById('cart-summary');
        if (subtotal && cur) cur.innerHTML = subtotal.innerHTML;
      })
      .catch(function () {});
  }

  function bool(v) { return v === 'true'; }

  /* Make the cart lines match what the ladder says the cart has earned. */
  function reconcile(root) {
    if (busy) return;
    var ops = [];
    // gift ladder ended Sunday Oct 4 2026 11:59:59pm PT: past the deadline nothing is wanted, even on a stale render
    var end = Number(root.getAttribute('data-ladder-end') || 0) * 1000;
    var over = end > 0 && Date.now() >= end;
    ['99', '149', '199'].forEach(function (r) {
      // data-gift-99-want does not camelCase in dataset (digit after the dash), so read attributes directly
      var v = root.getAttribute('data-gift-' + r);
      var want = !over && bool(root.getAttribute('data-gift-' + r + '-want'));
      var has = bool(root.getAttribute('data-gift-' + r + '-in'));
      if (want && !has) ops.push({ type: 'add', id: Number(v) });
      if (!want && has) ops.push({ type: 'remove', id: Number(v) });
    });
    // protection band moved while a protection line is in the cart: swap it
    var pin = Number(root.getAttribute('data-protect-in') || 0);
    var pwant = Number(root.getAttribute('data-protect-variant') || 0);
    var pallowed = bool(root.getAttribute('data-protect-allowed'));
    if (pin && !pallowed) ops.push({ type: 'remove', id: pin });
    else if (pin && pwant && pin !== pwant) { ops.push({ type: 'remove', id: pin }); ops.push({ type: 'add', id: pwant }); }
    ops = ops.filter(function (op) { var k = op.type + op.id; attempts[k] = (attempts[k] || 0) + 1; return attempts[k] <= 2; });
    if (!ops.length) return;
    run(ops, root);
  }

  function run(ops, root) {
    busy = true;
    var r = routes();
    var allOk = true;
    var chain = Promise.resolve();
    ops.forEach(function (op) {
      chain = chain.then(function () {
        var p = op.type === 'add'
          ? post(r.add, { items: [{ id: op.id, quantity: 1 }] })
          : post(r.update, { updates: (function () { var u = {}; u[op.id] = 0; return u; })() });
        return p.then(function (res) { if (!res.ok) allOk = false; });
      });
    });
    chain.then(function () { if (allOk) attempts = {}; busy = false; refresh(root); })
      .catch(function () { busy = false; refresh(root); });
  }

  /* The theme re-renders cart lines and the summary after a quantity change, but not this block.
     Re-fetch the section that rendered each block and swap the block in place, then reconcile. */
  var reloadTimer = null;
  function reloadAddons() {
    clearTimeout(reloadTimer);
    reloadTimer = setTimeout(function () {
      document.querySelectorAll('[data-cw-addons]').forEach(function (root) {
        var section = null;
        var drawer = root.closest('cart-drawer');
        if (drawer) {
          var ci = drawer.querySelector('cart-items');
          section = ci && ci.dataset.section;
        } else {
          var holder = document.getElementById('cw-addons-page');
          section = holder && holder.dataset.section;
        }
        if (!section) return;
        fetch(window.location.pathname + '?sections=' + section)
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var html = data[section];
            if (!html) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('[data-cw-addons]');
            var cur = document.querySelector(drawer ? 'cart-drawer [data-cw-addons]' : '#cw-addons-page [data-cw-addons]');
            if (fresh && cur) { cur.replaceWith(fresh); scan(); }
          })
          .catch(function () {});
      });
    }, 150);
  }

  function onToggle(evt) {
    var box = evt.target;
    if (!box.matches || !box.matches('[data-cw-toggle]')) return;
    var root = box.closest('[data-cw-addons]');
    var id = Number(box.dataset.variant);
    var kind = box.dataset.cwToggle;
    box.disabled = true;
    var ops = [];
    if (box.checked) {
      // a protection line of another band may still be in the cart; remove it first
      if (kind === 'protect') {
        var pin = Number(root.getAttribute('data-protect-in') || 0);
        if (pin && pin !== id) ops.push({ type: 'remove', id: pin });
      }
      ops.push({ type: 'add', id: id });
    } else {
      var cur = kind === 'protect' ? Number(root.getAttribute('data-protect-in') || id) : id;
      ops.push({ type: 'remove', id: cur });
    }
    run(ops, root);
  }

  // the theme's drawer JS rewrites the "Products (N)" count from cart.item_count, which includes hidden gift lines
  function fixCounts() {
    var root = document.querySelector('[data-cw-addons]');
    if (!root) return;
    var n = root.getAttribute('data-visible-count');
    if (n === null) return;
    var el = document.getElementById('cart-drawer__count');
    if (el && el.textContent !== '(' + n + ')') el.textContent = '(' + n + ')';
  }

  function scan() {
    fixCounts();
    document.querySelectorAll('[data-cw-addons]').forEach(function (root) {
      if (root.dataset.cwBound) return;
      root.dataset.cwBound = '1';
      root.addEventListener('change', onToggle);
      reconcile(root);
    });
  }

  // First paint, then every time the theme re-renders the drawer or cart page.
  document.addEventListener('DOMContentLoaded', scan);
  if (document.readyState !== 'loading') scan();
  var obs = new MutationObserver(function () { scan(); });
  obs.observe(document.documentElement, { childList: true, subtree: true });
  ['on:cart:add', 'on:line-item:change'].forEach(function (e) {
    document.addEventListener(e, function () { reloadAddons(); });
  });
})();
